<div class="{{ theme$ | async }} position-relative d-inline-block">
  <button type="button" class="btn" 
    [matTooltip]="'NOTIFICATION.NOTIFICATIONS' | translate" 
    matTooltipPosition="below" 
    (click)="toggleDropdown()">
    <i class="far fa-comment-alt font-icons pointer font-size-medium text-primary"></i>

    @if (unreadNotifications > 0) {
      <span class="position-absolute badge rounded-pill bg-danger text-white" style="top: 0px; right: 0px">
        {{ unreadNotifications }}
      </span>
    }
  </button>

  <!-- Panel -->
  @if (isDropdownOpen) {
    <div class="border rounded notifications-panel text-primary custom-shadow" (click)="$event.stopPropagation()">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h6 class="font-weight-bold m-0 ml-3">{{ 'NOTIFICATION.NOTIFICATIONS' | translate }}</h6>
        @if (notificationList?.length) {
          <button class="btn btn-link p-0 mr-3 text-muted underline-hover" (click)="clearAll()">
            <span>{{ 'NOTIFICATION.CLEAR_ALL' | translate }}</span>
          </button>
        }
      </div>
      <hr class="mb-0" />
      @if (!notificationList || notificationList.length === 0) {
        <div class="text-center text-muted font-size-medium mt-5">
          <span>{{ 'NOTIFICATION.NO_NOTIFICATIONS' | translate }}</span>
        </div>
      }
      @for (item of notificationList; track item; let i = $index; let last = $last) {
        <div
          [@fadeOut]="item.animationState"
          class="{{ theme$ | async }}"
          [ngClass]="[item.itemClass, 'notification-item', !item.isRead ? 'not-read' : '']">
          <div class="d-flex ml-3 py-3">
            <i class="fas mt-2 mr-3 notification-icon" [ngClass]="[item.notificationIcon, item.iconColor]"></i>
            <div class="flex-grow-1 d-flex flex-column" (click)="markAsRead(item._id)">
              <span>
                {{ item.message }}
              </span>
              <span class="text-muted">
                {{ item.startTS | dateTimeFormatPipe: 'dmyt' }}
              </span>
              @if (!item.openReleaseNotes && item.url) {
                <a
                  [href]="item.url"
                  target="_blank"
                  class="text-primary custom-link"
                  style="text-decoration: underline">
                  {{ 'NOTIFICATION.LEARN_MORE' | translate }}
                </a>
              }
              @if (item.openReleaseNotes) {
                <a
                  class="text-primary custom-link"
                  (click)="openReleaseNotes()"
                  style="text-decoration: underline; cursor: pointer">
                  {{ 'NOTIFICATION.RELEASE_NOTES.RELEASE_NOTES' | translate }}
                </a>
              }
            </div>
            @if (item.dismissible) {
              <div
                class="trash-button mx-3 font-weight-bold cursor-pointer font-size-regular"
                (click)="markAsDelete(item._id)">
                <i class="far fa-trash-alt"></i>
              </div>
            }
          </div>
          @if (!last) {
            <hr class="my-1" />
          }
        </div>
      }
    </div>
  }
</div>
